module.exports = __webpack_public_path__ + "img/peicon.dcb85736.png";